import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppConfig } from '../app.config';
import { ParticipantHeaderComponent } from '../_layout/participant-header/participant-header.component';
import { ParticipantFooterComponent } from '../_layout/participant-footer/participant-footer.component';
import { ParticipantHeaderComponent as LsrParticipantHeaderComponent } from '../LSR/_layout/participant-header/participant-header.component';
import { ParticipantFooterComponent as LsrParticipantFooterComponent } from '../LSR/_layout/participant-footer/participant-footer.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-unauthorized-user',
  standalone: true,
  imports: [
    CommonModule,
    ParticipantHeaderComponent,
    ParticipantFooterComponent,
    LsrParticipantHeaderComponent,
    LsrParticipantFooterComponent,
    RouterModule
  ],
  templateUrl: './unauthorized-user.html',
  styleUrls: ['./unauthorized-user.css'],
})
export class UnauthorizedUser {
  readonly isLsrTenant = (AppConfig.appsettings?.tenantId ?? '') === '2';
}
